import { Box, styled } from '@mui/material'

export const Stack: React.FC<
  React.ComponentProps<typeof Box> & { compact?: boolean }
> = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(compact ? 2 : 3),
  flex: 1,
}))
